module.exports = __webpack_public_path__ + "images/renault_smallb8ac9eb242bb1fb6d39125969d916edc.png";